import { createContext, useContext, useState } from "react";
import {
  fetchClientAndToken,
  fetchClientsIds,
  fetchConfig,
} from "../services/tipddy-v2/clients";

let LOCALHOST = "localhost";

const DEFAULT_CONFIG = {
  config: {
    theme: {
      colors: {
        primary_light: "#070A1E",
        primary_dark: "#070A1E",
        secondary_light: "#000E37",
        secondary_dark: "#000E37",
        tertiary_light: "#C5954F",
        tertiary_dark: "#C5954F",
        background_light: "#070A1E",
        background_dark: "#000323",
        button_light: "#D99749",
        button_dark: "#D99749",
        text_button_light: "#000323",
        text_button_dark: "#000323",
        text_navbar_light: "#ffffff",
        text_navbar_dark: "#ffffff",
        text_login_light: "#ffffff",
        text_login_dark: "#ffffff",
        background_banner_light: "#D99749",
        background_banner_dark: "#D99749",
        background_banner_button_light: "#CC934A",
        background_banner_button_dark: "#CC934A",
        background_body_light: "#ffffff",
        background_body_dark: "#101C3E",
        background_header_login: "#000323",
        background_body_login: "#000E37",
        background_pendiente_light: "#D99749",
        background_pendiente_dark: "#D99749",
        background_completado_light: "#4CAF50",
        background_completado_dark: "#4CAF50",
        background_tooltip_light: "#D99749",
        background_tooltip_dark: "#D99749",
      },
      logo: "/logo-colegio-ezer-horizontal.png",
      theme_logo_dark: "/logo-colegio-ezer-horizontal.png",
    },
  },
  token: "aab6e4d81d8250251c52c7724f329e56",
  titulo_interfaz: "Campus virtual",
  opciones: [],
  ID: 213670,
  baseURL: "https://campus.colegioezer.cl/",
};

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  let actions = {};

  actions.getConfig = async function () {
    try {
      let response = await fetchClientAndToken(213670);
      if (!response) {
        throw new Error("No se pudo obtener la configuración del cliente");
      }

      let config = {
        ...response.config,
        baseURL: response.client.baseMoodleURL,
      };

      document.title = config.titulo_interfaz || "Campus virtual";
      localStorage.setItem("config", "stage");
      setConfig({ ...config });
      return config;
    } catch (err) {
      console.warn(
        "Tipddy API falló, usando configuración por defecto:",
        err
      );
      document.title = DEFAULT_CONFIG.titulo_interfaz;
      setConfig({ ...DEFAULT_CONFIG });
      return DEFAULT_CONFIG;
    }
  };

  actions.verifyConfig = async function () {};

  actions.getClientId = ({ clients, domain }) => {
    console.log(clients);
    if (domain.includes(LOCALHOST)) {
      let host = domain.split(":")[0];
      let localhostClient = clients.find((c) =>
        c.baseInterfazURL?.includes(host)
      );
      /* return localhostClient; */

      return {
        ID: 26793,
        baseMoodleURL: 'https://e-aula.academia-tecnigen.cl',
        baseInterfazURL: 'https://participante.academia-tecnigen.cl/'
      }
    }
    
    let isValidClient = clients.find((c) =>
      c.baseInterfazURL?.includes(domain)
    ); 

    if (isValidClient) {
      return isValidClient;
    }
  };

  let value = {
    config,
    getConfig: actions.getConfig,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);

